export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7002131a8f2e1e0b1ba0739f6f498b6ff61b63d0c5&name=pushAdClickData!'